export const formatProductOptionLabel = (product: any) => {
  const productName = product?.product_name || "";
  const productCode = product?.product_code || "";
  const productCodePrefix = product?.product_code_prefix || "";
  const formattedCode = `${productCodePrefix}${productCode}`.trim();

  if (productName && formattedCode) {
    return `${productName} (${formattedCode})`;
  }

  return productName || formattedCode;
};
